import { IconButton, Typography, Link } from "@mui/material";
import { styled } from "@mui/material/styles";
import "react/jsx-runtime";
import { CloseIcon } from "../../../../../components/icons/CloseIcon/CloseIcon.js";
import { IncomingCallIcon } from "../../../../../components/icons/IncomingCallIcon/IncomingCallIcon.js";
import { OngoingCallIcon } from "../../../../../components/icons/OngoingCallIcon/OngoingCallIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
const Notification = styled("div")(({ theme }) => ({
  width: 346,
  borderRadius: 24,
  position: "relative",
  background: theme.palette.grey[800],
  marginTop: 0,
  padding: 16
}));
const CloseButton = styled(IconButton)(({ theme }) => ({
  width: 20,
  height: 20,
  position: "absolute",
  right: -4,
  top: -4,
  backgroundColor: "white",
  borderRadius: "100%",
  borderColor: theme.palette.grey[800],
  borderWidth: 1,
  borderStyle: "solid",
  padding: 0,
  zIndex: 10,
  minWidth: "unset",
  "&:hover": {
    backgroundColor: "white"
    // Overwrite default MUI hover which is transparent
  }
}));
const NotificationCloseIcon = styled(CloseIcon)(({ theme }) => ({
  width: 14,
  height: 14,
  fill: theme.palette.grey[800]
}));
const Content = styled("div")(() => ({
  display: "flex"
}));
const NotificationIcon = styled("div")(({ theme }) => ({
  minWidth: 48,
  height: 48,
  borderRadius: "100%",
  animation: "$pulse 1.5s infinite",
  alignSelf: "baseline",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "&.ringing": {
    backgroundColor: theme.palette.secondary[300]
  },
  "&.ongoing": {
    backgroundColor: theme.palette.success[400]
  }
}));
const NotificationIncomingCallIcon = styled(IncomingCallIcon)(() => ({
  width: 24,
  height: 24,
  color: "#fff",
  fill: "#fff",
  marginLeft: -3.5,
  marginTop: -2,
  animation: "icon 1.5s infinite",
  "@keyframes icon": {
    "0%": { transform: "translate3d(0em, 0, 0)" },
    "2%": { transform: "translate3d(0.05em, 0, 0)" },
    "4%": { transform: "translate3d(-0.05em, 0, 0)" },
    "6%": { transform: "translate3d(0.05em, 0, 0)" },
    "8%": { transform: "translate3d(-0.05em, 0, 0)" },
    "10%": { transform: "translate3d(0.05em, 0, 0)" },
    "12%": { transform: "translate3d(-0.05em, 0, 0)" },
    "14%": { transform: "translate3d(0.05em, 0, 0)" },
    "16%": { transform: "translate3d(-0.05em, 0, 0)" },
    "18%": { transform: "translate3d(0.05em, 0, 0)" },
    "20%": { transform: "translate3d(-0.05em, 0, 0)" },
    "22%": { transform: "translate3d(0.05em, 0, 0)" },
    "24%": { transform: "translate3d(-0.05em, 0, 0)" },
    "26%": { transform: "translate3d(0.05em, 0, 0)" },
    "28%": { transform: "translate3d(-0.05em, 0, 0)" },
    "30%": { transform: "translate3d(0.05em, 0, 0)" },
    "32%": { transform: "translate3d(-0.05em, 0, 0)" },
    "34%": { transform: "translate3d(0.05em, 0, 0)" },
    "36%": { transform: "translate3d(-0.05em, 0, 0)" },
    "38%": { transform: "translate3d(0.05em, 0, 0)" },
    "40%": { transform: "translate3d(-0.05em, 0, 0)" },
    "42%": { transform: "translate3d(0.05em, 0, 0)" },
    "44%": { transform: "translate3d(-0.05em, 0, 0)" },
    "46%": { transform: "translate3d(0em, 0, 0)" }
  }
}));
const NotificationOngoingCallIcon = styled(OngoingCallIcon)(() => ({
  width: 24,
  height: 24,
  color: "#fff",
  fill: "#fff",
  marginLeft: -3.5,
  marginTop: -2
}));
const TextContainer = styled("div")(() => ({
  marginLeft: 16,
  fontFamily: "Lato",
  display: "flex",
  flexDirection: "column"
}));
const CallStatus = styled(Typography)(({ theme }) => ({
  textTransform: "uppercase",
  fontSize: 10,
  lineHeight: "12px",
  letterSpacing: "0.5px",
  fontWeight: 700,
  "&.ringing": {
    color: theme.palette.secondary[300]
  },
  "&.ongoing": {
    color: theme.palette.success[400]
  }
}));
const Actions = styled("div")(() => ({
  width: "inherit",
  display: "flex",
  justifyContent: "flex-end"
}));
const Action = styled("div")(() => ({
  width: "max-content",
  fontWeight: 700,
  fontSize: 10,
  lineHeight: "12px",
  fontFamily: "Lato",
  display: "flex",
  textTransform: "uppercase",
  background: "#FFFFFF",
  color: "#212121",
  flexDirection: "row",
  padding: "4px 8px",
  justifyContent: "end",
  borderRadius: "100px"
}));
const PhoneContainer = styled("div")(() => ({
  display: "contents"
}));
const CallerName = styled(Typography)(() => ({
  fontWeight: 700,
  color: "#fff",
  fontSize: 17,
  lineHeight: "24px",
  fontFamily: "Lato"
}));
const CallerPhone = styled(Typography)(() => ({
  fontWeight: 400,
  color: "#fff",
  fontSize: 14,
  lineHeight: "20px",
  fontFamily: "Lato",
  letterSpacing: "0.25px"
}));
const NewAppointmentActionWrapper = styled("div")(() => ({
  "&.pointer": {
    cursor: "pointer"
  }
}));
const PatientActionWrapper = styled("div")(() => ({
  display: "flex",
  "&.pointer": {
    cursor: "pointer"
  }
}));
const PatientLink = styled(Link)(({ theme }) => ({
  color: theme.palette.common.white,
  textDecoration: "none",
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline"
  }
}));
export {
  Action,
  Actions,
  CallStatus,
  CallerName,
  CallerPhone,
  CloseButton,
  Content,
  NewAppointmentActionWrapper,
  Notification,
  NotificationCloseIcon,
  NotificationIcon,
  NotificationIncomingCallIcon,
  NotificationOngoingCallIcon,
  PatientActionWrapper,
  PatientLink,
  PhoneContainer,
  TextContainer
};
